import Request from '../Request.utils'
export interface IListInvoiceCapturesRequestQuery {
  documentType?: 'invoice' | 'credit-note';
  exceptionsOnly?: string;
  search?: string;
  status?: string;
}
export interface IGetInvoiceCaptureActivityRequestQuery {
  limit?: number;
}
export interface IListBcVendorsRequestQuery {
  q?: string;
  skip?: number;
  top?: number;
}
export interface IListBcAccountsRequestQuery {
  q?: string;
  skip?: number;
  top?: number;
}
export interface IGetInvoiceCaptureRequestParams {
  id: string;
}
export interface ICreateInvoiceCaptureRequestBody {
  extraction?: {
    currency?: string;
    documentKind?: string;
    documentType?: 'invoice' | 'credit-note';
    fields: {
      invoiceDate?: {
        confidence: number;
        edited?: boolean;
        value: string;
      };
      invoiceNumber?: {
        confidence: number;
        edited?: boolean;
        value: string;
      };
      poReference?: {
        confidence: number;
        edited?: boolean;
        value: string;
      };
      subtotal?: {
        confidence: number;
        edited?: boolean;
        value: string;
      };
      total?: {
        confidence: number;
        edited?: boolean;
        value: string;
      };
      vat?: {
        confidence: number;
        edited?: boolean;
        value: string;
      };
      vendorName?: {
        confidence: number;
        edited?: boolean;
        value: string;
      };
    };
    lineItems?: {
      amount?: number;
      confidence?: number;
      description?: string;
      glAccount?: string;
      quantity?: number;
      unitPrice?: number;
      vatCode?: string;
      vatRate?: number;
    }[];
    overallConfidence: number;
    pagesRendered?: number;
    provider?: string;
  };
  fileName: string;
  fileUrl?: string;
  mimeType?: string;
  source: 'upload' | 'email';
}
export interface IUpdateInvoiceCaptureRequestBody {
  lineItems?: {
    amount?: number;
    confidence?: number;
    description?: string;
    glAccount?: string;
    quantity?: number;
    unitPrice?: number;
    vatCode?: string;
    vatRate?: number;
  }[];
  postingDetails?: {
    dimension1?: string;
    dimension2?: string;
    glAccount?: string;
    vatCode?: string;
  };
  values?: {
    invoiceDate?: string;
    invoiceNumber?: string;
    poReference?: string;
    subtotal?: string;
    total?: string;
    vat?: string;
    vendorName?: string;
    vendorNo?: string | '' | null;
  };
}
export interface IUpdateInvoiceCaptureRequestParams {
  id: string;
}
export interface IApproveInvoiceCaptureRequestBody {
  queueToBc?: boolean;
}
export interface IApproveInvoiceCaptureRequestParams {
  id: string;
}
export interface IRejectInvoiceCaptureRequestBody {
  reason: string;
}
export interface IRejectInvoiceCaptureRequestParams {
  id: string;
}
export interface IOverrideInvoiceCapturePoRequestParams {
  id: string;
}
export interface IRematchInvoiceCaptureRequestParams {
  id: string;
}
export interface IRetryInvoiceCaptureSyncRequestParams {
  id: string;
}
export interface IRetryInvoiceCaptureExtractionRequestParams {
  id: string;
}
export interface IDeleteInvoiceCaptureRequestParams {
  id: string;
}
export interface IMarkInvoiceCaptureExceptionRequestBody {
  reason: string;
}
export interface IMarkInvoiceCaptureExceptionRequestParams {
  id: string;
}
export interface IGetInvoiceCaptureUploadUrlRequestBody {
  contentType: string;
  fileName: string;
}
export interface IExtractInvoiceCaptureRequestBody {
  dataBase64?: string;
  fileName: string;
  fileUrl?: string;
  mimeType?: string;
}
export interface IListVendorAliasesRequestQuery {
  vendorNo?: string;
}
export interface ICreateVendorAliasRequestBody {
  alias: string;
  vendorNo: string;
}
export interface IDeleteVendorAliasRequestParams {
  id: string;
}
export interface IListVendorPostingDefaultsRequestQuery {
  vendorNo?: string;
}
export interface IUpsertVendorPostingDefaultRequestBody {
  dimension1?: string;
  dimension2?: string;
  glAccount: string;
  vatCode?: string;
}
export interface IUpsertVendorPostingDefaultRequestParams {
  vendorNo: string;
}
export interface ISeedVendorPostingDefaultsCatalogRequestBody {}
export interface IListSupplierWorkflowsRequestQuery {
  vendorNo?: string;
}
export interface IGetSupplierWorkflowRequestParams {
  id: string;
}
export interface ICreateSupplierWorkflowRequestBody {
  action: {
    percent: number;
    type: 'early_settlement_discount';
  } | {
    glAccount: string;
    type: 'non_po_gl_coding';
    vatCode?: string;
  } | {
    chargeMatch: string;
    intoMatch?: string;
    type: 'combine_lines';
  } | {
    bcItemNo?: string;
    bcUnits: number;
    invoiceMatch?: string;
    invoiceUnits: number;
    type: 'unit_conversion';
  };
  conditions?: {
    /**
     * Unknown Property
     */
    [x: string]: unknown;
  };
  enabled?: boolean;
  name: string;
  priority?: number;
  vendorNo: string;
}
export interface IUpdateSupplierWorkflowRequestBody {
  action?: {
    percent: number;
    type: 'early_settlement_discount';
  } | {
    glAccount: string;
    type: 'non_po_gl_coding';
    vatCode?: string;
  } | {
    chargeMatch: string;
    intoMatch?: string;
    type: 'combine_lines';
  } | {
    bcItemNo?: string;
    bcUnits: number;
    invoiceMatch?: string;
    invoiceUnits: number;
    type: 'unit_conversion';
  };
  conditions?: {
    /**
     * Unknown Property
     */
    [x: string]: unknown;
  };
  enabled?: boolean;
  name?: string;
  priority?: number;
  vendorNo?: string;
}
export interface IUpdateSupplierWorkflowRequestParams {
  id: string;
}
export interface IDeleteSupplierWorkflowRequestParams {
  id: string;
}


class InvoiceCaptureAPI {
  listInvoiceCaptures = async (query: IListInvoiceCapturesRequestQuery) => {
    const res = await Request.call('/api/invoice-capture', 'GET', undefined, query, undefined, );
    return res;
  }
  getInvoiceCaptureStats = async () => {
    const res = await Request.call('/api/invoice-capture/stats/counts', 'GET', undefined, undefined, undefined, );
    return res;
  }
  getInvoiceCaptureActivity = async (query: IGetInvoiceCaptureActivityRequestQuery) => {
    const res = await Request.call('/api/invoice-capture/activity/recent', 'GET', undefined, query, undefined, );
    return res;
  }
  listBcVendors = async (query: IListBcVendorsRequestQuery) => {
    const res = await Request.call('/api/invoice-capture/bc/vendors', 'GET', undefined, query, undefined, );
    return res;
  }
  listBcAccounts = async (query: IListBcAccountsRequestQuery) => {
    const res = await Request.call('/api/invoice-capture/bc/accounts', 'GET', undefined, query, undefined, );
    return res;
  }
  listBcTaxCodes = async () => {
    const res = await Request.call('/api/invoice-capture/bc/tax-codes', 'GET', undefined, undefined, undefined, );
    return res;
  }
  listBcDimensions = async () => {
    const res = await Request.call('/api/invoice-capture/bc/dimensions', 'GET', undefined, undefined, undefined, );
    return res;
  }
  getInvoiceCapture = async (params: IGetInvoiceCaptureRequestParams) => {
    const res = await Request.call('/api/invoice-capture/:id', 'GET', params, undefined, undefined, );
    return res;
  }
  createInvoiceCapture = async (body: ICreateInvoiceCaptureRequestBody) => {
    const res = await Request.call('/api/invoice-capture', 'POST', undefined, undefined, body, );
    return res;
  }
  updateInvoiceCapture = async (params: IUpdateInvoiceCaptureRequestParams, body: IUpdateInvoiceCaptureRequestBody) => {
    const res = await Request.call('/api/invoice-capture/:id', 'PUT', params, undefined, body, );
    return res;
  }
  approveInvoiceCapture = async (params: IApproveInvoiceCaptureRequestParams, body: IApproveInvoiceCaptureRequestBody) => {
    const res = await Request.call('/api/invoice-capture/:id/approve', 'POST', params, undefined, body, );
    return res;
  }
  rejectInvoiceCapture = async (params: IRejectInvoiceCaptureRequestParams, body: IRejectInvoiceCaptureRequestBody) => {
    const res = await Request.call('/api/invoice-capture/:id/reject', 'POST', params, undefined, body, );
    return res;
  }
  overrideInvoiceCapturePo = async (params: IOverrideInvoiceCapturePoRequestParams) => {
    const res = await Request.call('/api/invoice-capture/:id/override-po', 'POST', params, undefined, undefined, );
    return res;
  }
  rematchInvoiceCapture = async (params: IRematchInvoiceCaptureRequestParams) => {
    const res = await Request.call('/api/invoice-capture/:id/rematch', 'POST', params, undefined, undefined, );
    return res;
  }
  retryInvoiceCaptureSync = async (params: IRetryInvoiceCaptureSyncRequestParams) => {
    const res = await Request.call('/api/invoice-capture/:id/retry-sync', 'POST', params, undefined, undefined, );
    return res;
  }
  retryInvoiceCaptureExtraction = async (params: IRetryInvoiceCaptureExtractionRequestParams) => {
    const res = await Request.call('/api/invoice-capture/:id/retry-extraction', 'POST', params, undefined, undefined, );
    return res;
  }
  deleteInvoiceCapture = async (params: IDeleteInvoiceCaptureRequestParams) => {
    const res = await Request.call('/api/invoice-capture/:id', 'DELETE', params, undefined, undefined, );
    return res;
  }
  markInvoiceCaptureException = async (params: IMarkInvoiceCaptureExceptionRequestParams, body: IMarkInvoiceCaptureExceptionRequestBody) => {
    const res = await Request.call('/api/invoice-capture/:id/mark-exception', 'POST', params, undefined, body, );
    return res;
  }
  getInvoiceCaptureUploadUrl = async (body: IGetInvoiceCaptureUploadUrlRequestBody) => {
    const res = await Request.call('/api/invoice-capture/upload-url', 'POST', undefined, undefined, body, );
    return res;
  }
  getBcPurchasingHealth = async () => {
    const res = await Request.call('/api/invoice-capture/bc/health', 'GET', undefined, undefined, undefined, );
    return res;
  }
  extractInvoiceCapture = async (body: IExtractInvoiceCaptureRequestBody) => {
    const res = await Request.call('/api/invoice-capture/extract', 'POST', undefined, undefined, body, );
    return res;
  }
  listVendorAliases = async (query: IListVendorAliasesRequestQuery) => {
    const res = await Request.call('/api/invoice-capture/vendor-aliases', 'GET', undefined, query, undefined, );
    return res;
  }
  createVendorAlias = async (body: ICreateVendorAliasRequestBody) => {
    const res = await Request.call('/api/invoice-capture/vendor-aliases', 'POST', undefined, undefined, body, );
    return res;
  }
  deleteVendorAlias = async (params: IDeleteVendorAliasRequestParams) => {
    const res = await Request.call('/api/invoice-capture/vendor-aliases/:id', 'DELETE', params, undefined, undefined, );
    return res;
  }
  listVendorPostingDefaults = async (query: IListVendorPostingDefaultsRequestQuery) => {
    const res = await Request.call('/api/invoice-capture/vendor-posting-defaults', 'GET', undefined, query, undefined, );
    return res;
  }
  upsertVendorPostingDefault = async (params: IUpsertVendorPostingDefaultRequestParams, body: IUpsertVendorPostingDefaultRequestBody) => {
    const res = await Request.call('/api/invoice-capture/vendor-posting-defaults/:vendorNo', 'PUT', params, undefined, body, );
    return res;
  }
  seedVendorPostingDefaultsCatalog = async (body: ISeedVendorPostingDefaultsCatalogRequestBody) => {
    const res = await Request.call('/api/invoice-capture/vendor-posting-defaults/seed-catalog', 'POST', undefined, undefined, body, );
    return res;
  }
  listSupplierWorkflows = async (query: IListSupplierWorkflowsRequestQuery) => {
    const res = await Request.call('/api/invoice-capture/supplier-workflows', 'GET', undefined, query, undefined, );
    return res;
  }
  getSupplierWorkflow = async (params: IGetSupplierWorkflowRequestParams) => {
    const res = await Request.call('/api/invoice-capture/supplier-workflows/:id', 'GET', params, undefined, undefined, );
    return res;
  }
  createSupplierWorkflow = async (body: ICreateSupplierWorkflowRequestBody) => {
    const res = await Request.call('/api/invoice-capture/supplier-workflows', 'POST', undefined, undefined, body, );
    return res;
  }
  updateSupplierWorkflow = async (params: IUpdateSupplierWorkflowRequestParams, body: IUpdateSupplierWorkflowRequestBody) => {
    const res = await Request.call('/api/invoice-capture/supplier-workflows/:id', 'PUT', params, undefined, body, );
    return res;
  }
  deleteSupplierWorkflow = async (params: IDeleteSupplierWorkflowRequestParams) => {
    const res = await Request.call('/api/invoice-capture/supplier-workflows/:id', 'DELETE', params, undefined, undefined, );
    return res;
  }
}
export default new InvoiceCaptureAPI()